class ReliupHomeVideoStories extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.tabs = Array.from(this.querySelectorAll('[data-video-story-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-video-story-panel]'));
    this.onTabClick = this.handleTabClick.bind(this);
    this.onTabKeydown = this.handleTabKeydown.bind(this);

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick);
      tab.addEventListener('keydown', this.onTabKeydown);
    });

    this.initialized = true;
  }

  disconnectedCallback() {
    this.tabs?.forEach((tab) => {
      tab.removeEventListener('click', this.onTabClick);
      tab.removeEventListener('keydown', this.onTabKeydown);
    });

    this.initialized = false;
  }

  handleTabClick(event) {
    this.selectStory(event.currentTarget.dataset.videoStoryTab);
  }

  handleTabKeydown(event) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let nextIndex = currentIndex;

    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;

    const nextTab = this.tabs[nextIndex];
    nextTab.focus();
    this.selectStory(nextTab.dataset.videoStoryTab);
  }

  selectStory(story) {
    const nextTab = this.tabs.find((tab) => tab.dataset.videoStoryTab === story);
    const nextPanel = this.panels.find((panel) => panel.dataset.videoStoryPanel === story);
    const currentPanel = this.panels.find((panel) => !panel.hidden);

    if (!nextTab || !nextPanel || currentPanel === nextPanel) return;

    currentPanel?.querySelector('video-media')?.pause();

    this.tabs.forEach((tab) => {
      const selected = tab === nextTab;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel !== nextPanel;
    });

    const nextMedia = nextPanel.querySelector('video-media');
    if (nextMedia?.hasAttribute('autoplay') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      requestAnimationFrame(() => nextMedia.play());
    }
  }
}

if (!customElements.get('reliup-home-video-stories')) {
  customElements.define('reliup-home-video-stories', ReliupHomeVideoStories);
}
